/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AzureDevOpsPipelineListProjectsRequest {
    getFixupPrototypeFunction() { return AzureDevOpsPipelineListProjectsRequest.fixupPrototype; }

    static newInstance(model: Partial<AzureDevOpsPipelineListProjectsRequest>): AzureDevOpsPipelineListProjectsRequest {
        let obj = Object.assign(new AzureDevOpsPipelineListProjectsRequest(), model);
        AzureDevOpsPipelineListProjectsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AzureDevOpsPipelineListProjectsRequest>): AzureDevOpsPipelineListProjectsRequest {
        if (!model) return null;
        return AzureDevOpsPipelineListProjectsRequest.newInstance(<AzureDevOpsPipelineListProjectsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AzureDevOpsPipelineListProjectsRequest) {
        if (!obj) return;

        models.AzureDevOpsPipelineListProjectsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AzureDevOpsPipelineListProjectsRequest): boolean {
        Object.setPrototypeOf(obj, AzureDevOpsPipelineListProjectsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Service Account ID
     */
    service_account_id: string;

}
